<template>
  <div class='h-100'>
    <TraceDetail :tracableInfo='tracableInfo' v-if='tracableInfo'></TraceDetail>
    <sensorDetailDialog></sensorDetailDialog>
    <gatewayDetailDialog></gatewayDetailDialog>
    <displayDetailDialog></displayDetailDialog>
    <relayDetailDialog></relayDetailDialog>
  </div>
</template>

<script>
import TraceDetail from '../components/ArchDetail/TraceDetail.vue'
import { mapTrackcarrierTraceState } from '@/api/modules/map'
import sensorDetailDialog from '@/components/dialog/sensorDetail/sensorDetailDialog'
import gatewayDetailDialog from '@/components/dialog/gatewayDetail/gatewayDetailDialog'
import displayDetailDialog from '@/components/dialog/displayDetail/displayDetailDialog'
import relayDetailDialog from '@/components/dialog/relayDetail/relayDetailDialog'

export default {
  components: {
    TraceDetail,
    sensorDetailDialog,
    gatewayDetailDialog,
    displayDetailDialog,
    relayDetailDialog
  },
  data () {
    return {
      tracableInfo: null
    }
  },
  methods: {
    async initInfo () {
      this.tracableInfo = (await mapTrackcarrierTraceState({ id: this.$route.query.id })).result
    }
  },
  mounted () {
    this.initInfo()
  }
}
</script>

<style scoped lang='scss'></style>
